import { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  css?: any
}

const TOSComponent = ({ ...rest }: Props) => (
  <div {...rest}>
    <Typography css={tw`text-center text-shades-400`}>By continuing, you are</Typography>
    <Typography css={tw`text-center text-shades-400`}>
      agreeing to our &nbsp;
      <a css={tw`no-underline`} href="https://www.gigsafe.com/terms" target="_blank">
        <Typography css={tw`cursor-pointer underline inline-block text-primary-500`} variant="h4">
          Terms of Service
        </Typography>
      </a>
    </Typography>
  </div>
)

export const TOS = memo(TOSComponent)
